import Schedule from './ScheduleContainer';

export default Schedule;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Schedule/index.js